webpackJsonp([11],{

/***/ 1167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderArchivedTable_vue__ = __webpack_require__(2840);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a376f6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderArchivedTable_vue__ = __webpack_require__(4813);
function injectStyle (ssrContext) {
  __webpack_require__(4811)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a376f6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderArchivedTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a376f6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderArchivedTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      archivedFields: [{
        prop: 'taskid',
        label: '任务ID',
        formatter: function formatter(row) {
          return 'TSK' + row.taskid;
        }
      }, {
        prop: 'title',
        label: '任务标题'
      }, {
        prop: 'type',
        label: '任务类型',
        formatter: function formatter(row) {
          return _this.getOptionLabel('allType', row.type);
        }
      }, {
        prop: 'assignnum',
        label: '完成人'
      }, {
        prop: 'salary',
        label: '赏金',
        formatter: function formatter(row) {
          return filter.hasPermission(250) ? row.salary : '*';
        }
      }, {
        prop: 'starttime_endtime',
        label: '任务时间',
        formatter: function formatter(row) {
          return row.starttime + '\n' + row.endtime;
        },
        width: '160px'
      }, {
        prop: 'city',
        label: '城市',
        formatter: function formatter(row) {
          return '' + row.provincename + row.cityname + row.areaname;
        }
      }, {
        prop: 'marketname',
        label: '门店名称'
      }, {
        prop: 'status',
        label: '任务状态',
        formatter: function formatter(row) {
          return _this.getOptionLabel('status', row.status);
        }
      }, {
        prop: 'adminname',
        label: '任务发布人'
      }, {
        prop: 'customerid',
        label: '所属客户',
        formatter: function formatter(row) {
          return row.customerid ? row.customer_name + '/' + row.customer_number : '平台';
        }
      }, {
        prop: 'publishtime',
        label: '发布时间',
        formatter: function formatter(row) {
          return '' + row.publishtime;
        },
        width: '160px'
      }],
      orderArchivedFields: [{
        prop: 'orderid',
        label: '工单ID',
        formatter: function formatter(row) {
          return 'ORD' + row.orderid;
        }
      }, {
        prop: 'title',
        label: '任务标题'
      }, {
        prop: 'type',
        label: '任务类型',
        formatter: function formatter(row) {
          return _this.getOptionLabel('allType', row.type);
        }
      }, {
        prop: 'userid',
        label: '完成人'
      }, {
        prop: 'salary',
        label: '赏金',
        formatter: function formatter(row) {
          return filter.hasPermission(250) ? row.salary : '*';
        }
      }, {
        prop: 'starttime_endtime',
        label: '任务时间',
        formatter: function formatter(row) {
          return row.starttime + '\n' + row.endtime;
        },
        width: '160px'
      }, {
        prop: 'city',
        label: '城市',
        formatter: function formatter(row) {
          return '' + row.provincename + row.cityname + row.areaname;
        }
      }, {
        prop: 'marketname',
        label: '门店名称'
      }, {
        prop: 'status',
        label: '任务状态',
        formatter: function formatter(row) {
          return _this.getOptionLabel('status', row.status);
        }
      }, {
        prop: 'adminname',
        label: '任务发布人'
      }, {
        prop: 'customerid',
        label: '所属客户',
        formatter: function formatter(row) {
          return row.customerid ? row.customer_name + '/' + row.customer_number : '平台';
        }
      }, {
        prop: 'review',
        label: '审核次数'
      }, {
        prop: 'publishtime',
        label: '发布/更新时间',
        formatter: function formatter(row) {
          return row.publishtime + '\n' + (row.lastupdatetime || '');
        },
        width: '160px'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  })),
  methods: {
    onUploadFile: function onUploadFile(file, taskType) {
      var _this2 = this;

      var fileType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (taskType === 231) {
        fileType = 8;
      }

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.raw);
      formData.append('collection_type', 2); // 集合类型为2
      formData.append('type', taskType);
      formData.append('file_type', fileType);

      request.common('createTaskBatch', formData).then(function (_ref) {
        var data = _ref.data;

        _this2.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this2.onSearch();
      });
    },
    createTaskBatch: function createTaskBatch(file) {
      var _this3 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('createTaskBatchJob', formData).then(function (_ref2) {
        var data = _ref2.data;

        _this3.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this3.onSearch();
      });
    },
    createTaskBatchWithTemplate: function createTaskBatchWithTemplate(file) {
      var _this4 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('createTaskWithTemplateBatchJob', formData).then(function (_ref3) {
        var data = _ref3.data;

        _this4.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this4.onSearch();
      });
    },
    uploadAuditReferenceBatch: function uploadAuditReferenceBatch(file) {
      var _this5 = this;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        return false;
      }
      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('importTaskAuditReferenceBatchJob', formData).then(function () {
        _this5.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this5.onSearch();
      });
    },
    editTaskBatch: function editTaskBatch(file) {
      var _this6 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('editTaskBatchJob', formData).then(function (_ref4) {
        var data = _ref4.data;

        _this6.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this6.onSearch();
      });
    },
    deleteTaskBatch: function deleteTaskBatch(file) {
      var _this7 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('deleteTaskBatchJob', formData).then(function (_ref5) {
        var data = _ref5.data;

        _this7.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this7.onSearch();
      });
    },
    reactivateTaskBatch: function reactivateTaskBatch(file) {
      var _this8 = this;

      var formData = new FormData();
      formData.append('file', file.raw);

      request.common('reactivateTaskBatchJob', formData).then(function (_ref6) {
        var data = _ref6.data;

        _this8.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this8.onSearch();
      });
    },

    // 解析上传的excel文件 看一下是否超过MaxRowLimit
    parseExcelFile: function parseExcelFile(file) {
      var maxRowLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20000;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var isSatisfy = true;
        var errorMessage = '';
        // 先校验一下文件的大小
        var isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          isSatisfy = false;
          errorMessage = '上传表格行数超过10M，可能引起性能故障并导致更新失败。请与产品联系后上传，产品开发将关注后续更新情况。';
          return resolve({ isSatisfy: isSatisfy, errorMessage: errorMessage });
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          try {
            var data = new Uint8Array(e.target.result);
            var workbook = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.read(data, { type: 'array' });

            var firstSheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[firstSheetName];

            var jsonData = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.utils.sheet_to_json(worksheet, { header: 1 });
            // 计算数据条数，减去第一行标题
            var rowCount = jsonData.length - 1;
            // 超过限定的长度
            if (rowCount > maxRowLimit) {
              isSatisfy = false;
              errorMessage = '\u4E0A\u4F20\u8868\u683C\u884C\u6570\u8D85\u8FC7' + maxRowLimit + '\u6761\uFF0C\u53EF\u80FD\u5F15\u8D77\u6027\u80FD\u6545\u969C\u5E76\u5BFC\u81F4\u66F4\u65B0\u5931\u8D25\u3002\u8BF7\u4E0E\u4EA7\u54C1\u8054\u7CFB\u540E\u4E0A\u4F20\uFF0C\u4EA7\u54C1\u5F00\u53D1\u5C06\u5173\u6CE8\u540E\u7EED\u66F4\u65B0\u60C5\u51B5\u3002';
            } else {
              isSatisfy = true;
            }
            return resolve({ isSatisfy: isSatisfy, errorMessage: errorMessage });
          } catch (error) {
            reject(Error('\u6587\u4EF6\u89E3\u6790\u5931\u8D25: ' + error.message));
            throw new Error(error);
          }
        };
        reader.onerror = function () {
          reject(Error('文件读取失败'));
        };
        reader.readAsArrayBuffer(file);
      });
    },

    // 上传任务可执行时间段 需要先校验一下他的行数
    taskAvailableTimeBatch: function taskAvailableTimeBatch(file) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref7, isSatisfy, errorMessage;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this9.$store.commit('OPEN_LOADING');
                _context.next = 4;
                return _this9.parseExcelFile(file.raw, 20000);

              case 4:
                _ref7 = _context.sent;
                isSatisfy = _ref7.isSatisfy;
                errorMessage = _ref7.errorMessage;

                _this9.$store.commit('CLOSE_LOADING');
                // 超过限制 提示

                if (isSatisfy) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 9;
                _context.next = 12;
                return _this9.$confirm(errorMessage, '警告', {
                  type: 'warning',
                  confirmButtonText: '已联系，继续操作',
                  cancelButtonText: '取消'
                });

              case 12:
                _context.next = 14;
                return _this9.uploadTaskAvailableTimeBatch(file);

              case 14:
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](9);

                _this9.$message.info('已取消上传');
                throw new Error(_context.t0);

              case 20:
                _context.next = 24;
                break;

              case 22:
                _context.next = 24;
                return _this9.uploadTaskAvailableTimeBatch(file);

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t1 = _context['catch'](0);

                _this9.$message.error(_context.t1);
                throw new Error(_context.t1);

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9, [[0, 26], [9, 16]]);
      }))();
    },

    // 上传excel
    uploadTaskAvailableTimeBatch: function uploadTaskAvailableTimeBatch(file) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();

                formData.append('file', file.raw);
                _context2.next = 4;
                return request.common('taskAvailableTimeBatchJob', formData);

              case 4:
                _this10.$message({
                  showClose: true,
                  message: '上传成功',
                  type: 'success'
                });
                _this10.onSearch();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this10);
      }))();
    },

    // 任务可执行时间端 点击
    confirmTaskAvailableTimeBatch: function confirmTaskAvailableTimeBatch(e) {
      e.stopPropagation();
      this.$refs['upload'].$refs['upload-inner'].handleClick();
    },
    onPublishTask: function onPublishTask(task) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var totalSalary;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!moment(task.taskendtime).isBefore(moment())) {
                  _context3.next = 4;
                  break;
                }

                _this11.$message.error('任务结束时间必须大于当前时间');
                _context3.next = 15;
                break;

              case 4:
                totalSalary = _.round(task.hirenum * task.salary, 2);
                _context3.next = 7;
                return _this11.$prompt('\u4EFB\u52A1[' + task.taskid + ']\u7684\u62A5\u916C' + task.salary + '\u5143\uFF0C\u9700\u8981' + task.hirenum + '\u4EBA\uFF0C\u8BF7\u8F93\u5165\u603B\u91D1\u989D\uFF1A' + totalSalary, '提示', {
                  confirmButtonText: '发布',
                  cancelButtonText: '取消',
                  inputPattern: new RegExp('^' + totalSalary + '$'),
                  inputErrorMessage: '金额输入错误',
                  inputPlaceholder: totalSalary,
                  closeOnClickModal: false
                });

              case 7:
                _context3.next = 9;
                return request.alert('taskPublish', { taskid: task.taskid });

              case 9:
                _this11.$store.commit('OPEN_LOADING');
                _context3.next = 12;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                  setTimeout(function () {
                    resolve();
                    _this11.$store.commit('CLOSE_LOADING');
                  }, 2000);
                });

              case 12:
                _context3.next = 14;
                return _this11.onRefresh();

              case 14:

                _this11.$message({
                  showClose: true,
                  message: '\u4EFB\u52A1[' + task.taskid + ']\u53D1\u5E03\u6210\u529F',
                  type: 'success'
                });

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this11);
      }))();
    },
    getOptionLabel: function getOptionLabel(optType, val) {
      var type = this.options[optType].find(function (one) {
        return one.value === val;
      });
      return type ? type.label : '';
    },
    countDown: function countDown(date) {
      var futureTs = (Date.parse(date) + '').substr(0, 10);
      var currentTs = (new Date().getTime() + '').substr(0, 10);
      var interval = futureTs - currentTs;

      if (interval < 0) {
        return '';
      }

      return filter.formatTimerHumanize(interval);
    }
  }
});

/***/ }),

/***/ 1514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TaskDescButton'
});

/***/ }),

/***/ 1515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getExel */
/* unused harmony export getExelByPost */
/* harmony export (immutable) */ __webpack_exports__["a"] = NumberArray;
/* unused harmony export StringArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var base = window._env_.VUE_APP_HOST;
function getExel(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'GET',
      url: base + url,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer',
      params: params
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}
function getExelByPost(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'post',
      url: base + url,
      data: params,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer'
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}

// 将字符串数组转换为数字数组
function NumberArray(value) {
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return Number(item);
  });
}

function StringArray(value) {
  // 如果 value 不是数组，则将其转换成数组
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return String(item);
  });
}

/***/ }),

/***/ 1548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_area_components_ContainmentAreaCascader__ = __webpack_require__(1600);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ContainmentAreaCascader: __WEBPACK_IMPORTED_MODULE_1__views_area_components_ContainmentAreaCascader__["a" /* default */]
  },
  props: {
    searchValue: Object,
    showAddtoTaskgroupTargetNum: {
      type: Boolean,
      default: false
    },
    showExcludeProject: {
      type: Boolean,
      default: false
    },
    showPlatformSearch: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1 // 1工单 2任务 3任务&工单
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  }), Vuex.mapGetters('order', ['getSortedTaskTypes']), {
    search: function search() {
      return this.searchValue;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail']), Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']), {
    onSearch: function onSearch() {
      if (this.search.onlineRange) {
        this.searchValue.start_begin = this.search.onlineRange[0];
        this.searchValue.start_end = this.search.onlineRange[1];
      }
      if (this.search.offlineRange) {
        this.searchValue.endtime_begin = this.search.offlineRange[0];
        this.searchValue.endtime_end = this.search.offlineRange[1];
      }
      if (this.search.lastupdatetimeRange) {
        this.searchValue.lastupdatetime_begin = this.search.lastupdatetimeRange[0];
        this.searchValue.lastupdatetime_end = this.search.lastupdatetimeRange[1];
      }
      if (this.search.userfinishtime) {
        this.searchValue.userfinishtime_begin = this.search.userfinishtime[0];
        this.searchValue.userfinishtime_end = this.search.userfinishtime[1];
      }
      this.$emit('onSearch');
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.search.query_areas = [];
      if (this.type === 1) {
        this.search.finish_query_areas = [];
      }
    },
    projectIdChanged: function projectIdChanged() {
      if (this.search.batchid.length > 0) {
        this.search.batchid = [];
      }
    }
  })
});

/***/ }),

/***/ 1549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);

//
//
//
//
//
//
//
//
//
//
//
//
//

/** 省市区多选；v-model 为 ["1","1,2","1,2,3"] */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContainmentAreaCascader',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data: function data() {
    return {
      chinaAreaData: []
    };
  },

  computed: {
    cascaderValue: function cascaderValue() {
      return (this.value || []).map(function (s) {
        return String(s).split(',').map(Number).filter(function (n) {
          return !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(n);
        });
      }).filter(function (p) {
        return p.length;
      });
    }
  },
  created: function created() {
    var _this = this;

    request.alert('queryAllFormatted').then(function (_ref) {
      var data = _ref.data;

      _this.chinaAreaData = Array.isArray(data) ? data : Array.isArray(data && data.data) ? data.data : [];
    }).catch(function () {
      _this.chinaAreaData = [];
    });
  },

  methods: {
    onInput: function onInput(paths) {
      var next = (paths || []).map(function (p) {
        return p.join(',');
      });
      this.$emit('input', next);
      this.$emit('change', next);
    }
  }
});

/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDescButton_vue__ = __webpack_require__(1514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbc218e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDescButton_vue__ = __webpack_require__(1558);
function injectStyle (ssrContext) {
  __webpack_require__(1556)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbc218e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskDescButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbc218e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskDescButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1557);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("39328c12", content, true, {});

/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TaskDescButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticStyle:{"position":"absolute","right":"200px","bottom":"18px","color":"red"},attrs:{"href":"https://slicejobs-tech.feishu.cn/wiki/IFSEwU6zhi3fetk53uScDxFPnwh","target":"_blank"}},[_vm._v("查看任务&工单&证据归档说明\n  ")]),_vm._v(" "),_c('a',{staticStyle:{"position":"absolute","right":"10px","bottom":"18px"},attrs:{"href":"http://img-cn-shanghai.aliyuncs.com/taskdesc/190603/50/ad816a4cf26d21609f15540fa701c174.png","target":"_blank"}},[_vm._v("查看任务&工单&零工说明\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var HOUR_OPTIONS = [1, 3, 6, 12];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderResetProcessForm',
  data: function data() {
    return {
      hours: 3,
      hourOptions: HOUR_OPTIONS
    };
  },

  methods: {
    getValue: function getValue() {
      return this.hours;
    }
  }
});

/***/ }),

/***/ 1600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainmentAreaCascader_vue__ = __webpack_require__(1549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_647e61fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainmentAreaCascader_vue__ = __webpack_require__(1659);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContainmentAreaCascader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_647e61fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContainmentAreaCascader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    batchid: String
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  }), {
    search: function search() {
      return this.searchValue;
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$confirm('是否按批次通过工单?', '操作确认', {}).then(function () {
        _this.passByBatchId();
      }).catch(function (action) {
        console.log('取消按批次批量通过操作');
      });
    },
    passByBatchId: function passByBatchId() {
      var _this2 = this;

      return request.alert('onBatchSuccceed', { batchid: this.batchid }).then(function (res) {
        _this2.$message({
          showClose: true,
          message: '按批次批量通过成功,请前往批量任务查看',
          type: 'success'
        });
      });
    }
  }
});

/***/ }),

/***/ 1602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    batchid: String
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  }), {
    search: function search() {
      return this.searchValue;
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$confirm('是否确认按批次（已抢单、进行中）收回?', '操作确认', {}).then(function () {
        _this.onRequest();
      }).catch(function (action) {
        console.log('取消按批次收回工单操作');
      });
    },
    onRequest: function onRequest() {
      var _this2 = this;

      return request.alert('onBatchWithdraw', { batchid: this.batchid }).then(function (res) {
        _this2.$message({
          showClose: true,
          message: '按批次收回成功,请前往批量任务查看',
          type: 'success'
        });
      });
    }
  }
});

/***/ }),

/***/ 1603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__order_rules__ = __webpack_require__(1783);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    batchid: String
  },
  data: function data() {
    return {
      batchRules: __WEBPACK_IMPORTED_MODULE_2__order_rules__["a" /* batchRules */],
      loading: false,
      dialogFormVisible: false,
      innerVisible: false,
      form: {
        file: null,
        starttime: null,
        order_id: null,
        batch_id: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    }
  })),
  watch: {
    dialogFormVisible: function dialogFormVisible(value) {
      if (!value) {
        this.$refs.uploadThumb.clearFiles();
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      }
    }
  },
  methods: {
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!');
      }
      return isLt2M;
    },
    uploadRequest: function uploadRequest(obj) {
      this.form.file = obj.file;
    },
    onOpenInner: function onOpenInner() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.innerVisible = true;
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    onDetection: function onDetection() {
      var _this2 = this;

      var data = new FormData();
      data.append('file', this.form.file);
      data.append('starttime', this.form.starttime);
      data.append('batch_id', this.batchid);

      return request.common('onBatchCheckDetection', data).then(function (res) {
        _this2.$message('检测成功');
        _this2.dialogFormVisible = false;
        _this2.innerVisible = false;
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      var data = new FormData();
      data.append('file', this.form.file);
      data.append('starttime', this.form.starttime);
      data.append('order_id', this.form.orderid);
      data.append('batch_id', this.batchid);

      return request.common('onBatchCheckDetection', data).then(function (res) {
        _this3.$message('请前往批量任务中确认');
        _this3.dialogFormVisible = false;
        _this3.innerVisible = false;
      });
    }
  }
});

/***/ }),

/***/ 1658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSearch_vue__ = __webpack_require__(1548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ddb167e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSearch_vue__ = __webpack_require__(1660);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ddb167e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{staticClass:"width-max",attrs:{"value":_vm.cascaderValue,"options":_vm.chinaAreaData,"props":{ multiple: true, checkStrictly: true },"filterable":"","clearable":"","placeholder":_vm.placeholder},on:{"input":_vm.onInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-panel',{attrs:{"collapse":true}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"任务上线时间","prop":"onlineRange"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.onlineRange),callback:function ($$v) {_vm.$set(_vm.search, "onlineRange", $$v)},expression:"search.onlineRange"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务下线时间","prop":"offlineRange"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.offlineRange),callback:function ($$v) {_vm.$set(_vm.search, "offlineRange", $$v)},expression:"search.offlineRange"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务更新时间","prop":"lastupdatetimeRange"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.lastupdatetimeRange),callback:function ($$v) {_vm.$set(_vm.search, "lastupdatetimeRange", $$v)},expression:"search.lastupdatetimeRange"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目 名称/编号 进行搜索","query-request":_vm.getProjectTable,"find-request":_vm.getProjectDetail},on:{"change":function($event){return _vm.projectIdChanged()}},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),(_vm.showExcludeProject)?_c('el-form-item',{attrs:{"label":"排除项目","prop":"not_projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目 名称/编号 进行搜索","query-request":_vm.getProjectTable,"find-request":_vm.getProjectDetail},model:{value:(_vm.search.not_projectid),callback:function ($$v) {_vm.$set(_vm.search, "not_projectid", $$v)},expression:"search.not_projectid"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"订单类型","prop":"type"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择订单类型","clearable":""},model:{value:(_vm.search.type),callback:function ($$v) {_vm.$set(_vm.search, "type", $$v)},expression:"search.type"}},_vm._l((_vm.getSortedTaskTypes),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}},[(item.deprecated)?[_c('span',{staticStyle:{"float":"left","color":"#9ba0a5"}},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.desc)+"\n                ")])]:[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.desc))])]],2)}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次","prop":"batchid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","disabled":!_vm.search.projectid,"id-key":"number","label-key":"detail","value-key":"id","placeholder":"请输入批次 名称/编号 进行搜索","query-request":function (_) { return _vm.getBatchTable(Object.assign({projectid: _vm.search.projectid}, _)); },"find-request":_vm.getBatchDetail},model:{value:(_vm.search.batchid),callback:function ($$v) {_vm.$set(_vm.search, "batchid", $$v)},expression:"search.batchid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"订单状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"multiple":"","placeholder":"请选择订单状态","clearable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},[(_vm.type === 1)?_vm._l((_vm.options.orderstatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":String(item.value)}})}):(_vm.type === 2)?_vm._l((_vm.options.taskstatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":String(item.value)}})}):(_vm.type === 3)?_vm._l((_vm.options.status),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":String(item.value)}})}):_vm._e()],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务模板ID","prop":"templateid"}},[_c('el-input',{attrs:{"placeholder":"请输入任务模板id"},model:{value:(_vm.search.templateid),callback:function ($$v) {_vm.$set(_vm.search, "templateid", $$v)},expression:"search.templateid"}})],1),_vm._v(" "),(_vm.type !== 2)?_c('el-form-item',{attrs:{"label":"完成人ID","prop":"userid"}},[_c('el-input',{attrs:{"placeholder":"请输入完成人id","clearable":""},model:{value:(_vm.search.userid),callback:function ($$v) {_vm.$set(_vm.search, "userid", $$v)},expression:"search.userid"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所在区域","prop":"taskmarketareaid"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择所在区域","clearable":""},model:{value:(_vm.search.taskmarketareaid),callback:function ($$v) {_vm.$set(_vm.search, "taskmarketareaid", $$v)},expression:"search.taskmarketareaid"}},_vm._l((_vm.options.taskmarketareaid),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省市区","prop":"query_areas"}},[_c('containment-area-cascader',{attrs:{"placeholder":"请选择省市区"},model:{value:(_vm.search.query_areas),callback:function ($$v) {_vm.$set(_vm.search, "query_areas", $$v)},expression:"search.query_areas"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"超市名称","prop":"marketname"}},[_c('el-input',{attrs:{"placeholder":"请输入超市名称"},model:{value:(_vm.search.marketname),callback:function ($$v) {_vm.$set(_vm.search, "marketname", $$v)},expression:"search.marketname"}})],1),_vm._v(" "),(_vm.type !== 2)?_c('el-form-item',{attrs:{"label":"锁定状态","prop":"locked"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择锁定状态","clearable":""},model:{value:(_vm.search.locked),callback:function ($$v) {_vm.$set(_vm.search, "locked", $$v)},expression:"search.locked"}},_vm._l((_vm.options.locked),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.type !== 2)?_c('el-form-item',{staticClass:"re-el-form__interval",attrs:{"label":"审核次数"}},[_c('el-row',[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"review_begin","label-width":"0px"}},[_c('el-input',{attrs:{"placeholder":"最小值"},model:{value:(_vm.search.review_begin),callback:function ($$v) {_vm.$set(_vm.search, "review_begin", $$v)},expression:"search.review_begin"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('span',[_vm._v("~")])]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"review_end","label-width":"0px"}},[_c('el-input',{attrs:{"placeholder":"最大值"},model:{value:(_vm.search.review_end),callback:function ($$v) {_vm.$set(_vm.search, "review_end", $$v)},expression:"search.review_end"}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.type === 1)?_c('el-form-item',{staticClass:"re-el-form__interval",attrs:{"label":"用户完成时间","prop":"userfinishtime"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","clearable":"","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.userfinishtime),callback:function ($$v) {_vm.$set(_vm.search, "userfinishtime", $$v)},expression:"search.userfinishtime"}})],1):_vm._e(),_vm._v(" "),(_vm.type === 1)?_c('el-form-item',{staticClass:"re-el-form__interval",attrs:{"label":"初审管理员","prop":"first_reviewerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":_vm.getPlatformUsersIndex,"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.first_reviewerid),callback:function ($$v) {_vm.$set(_vm.search, "first_reviewerid", $$v)},expression:"search.first_reviewerid"}})],1):_vm._e(),_vm._v(" "),(_vm.showAddtoTaskgroupTargetNum)?_c('el-form-item',{attrs:{"label":"目标数标记","prop":"addto_taskgroup_target_num"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',[_vm._v("目标数标记"),_c('el-tooltip',{attrs:{"content":"自动群组目标数标记任务"}},[_c('i',{staticClass:"el-icon-warning"})])],1)]},proxy:true}],null,false,3089044144)},[_vm._v(" "),_c('el-select',{staticClass:"width-max",attrs:{"clearable":""},model:{value:(_vm.search.addto_taskgroup_target_num),callback:function ($$v) {_vm.$set(_vm.search, "addto_taskgroup_target_num", $$v)},expression:"search.addto_taskgroup_target_num"}},_vm._l((_vm.options.addto_taskgroup_target_num),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.showPlatformSearch)?_c('el-form-item',{attrs:{"label":"签到平台","prop":"start_app_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":""},model:{value:(_vm.search.start_app_type),callback:function ($$v) {_vm.$set(_vm.search, "start_app_type", $$v)},expression:"search.start_app_type"}},_vm._l((_vm.options.app_type_list),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.showPlatformSearch)?_c('el-form-item',{attrs:{"label":"提交平台","prop":"finish_app_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":""},model:{value:(_vm.search.finish_app_type),callback:function ($$v) {_vm.$set(_vm.search, "finish_app_type", $$v)},expression:"search.finish_app_type"}},_vm._l((_vm.options.app_type_list),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.showPlatformSearch)?_c('el-form-item',{attrs:{"label":"工单自主激活","prop":"reactive_by_user"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":""},model:{value:(_vm.search.reactive_by_user),callback:function ($$v) {_vm.$set(_vm.search, "reactive_by_user", $$v)},expression:"search.reactive_by_user"}},[_c('el-option',{attrs:{"label":"是","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"否","value":2}})],1)],1):_vm._e()],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"关键字","prop":"text"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请输入关键字","clearable":""},model:{value:(_vm.search.text),callback:function ($$v) {_vm.$set(_vm.search, "text", $$v)},expression:"search.text"}})],1),_vm._v(" "),(_vm.type === 1)?_c('el-form-item',{attrs:{"label":"用户提交位置","prop":"finish_query_areas"}},[_c('containment-area-cascader',{attrs:{"placeholder":"请选择用户提交位置"},model:{value:(_vm.search.finish_query_areas),callback:function ($$v) {_vm.$set(_vm.search, "finish_query_areas", $$v)},expression:"search.finish_query_areas"}})],1):_vm._e()],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"mini"}},[_vm._v("搜索\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.resetForm('searchForm')}}},[_vm._v("重置\n      ")])],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderTable_vue__ = __webpack_require__(2835);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e97b5cac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderTable_vue__ = __webpack_require__(4796);
function injectStyle (ssrContext) {
  __webpack_require__(4794)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e97b5cac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e97b5cac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1690:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    multipleSelection: Array
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      var multipleIds = {
        'order_ids': this.multipleSelection.map(function (item) {
          return item.orderid;
        })
      };
      if (multipleIds.order_ids.length <= 0) {
        this.$message.error('请至少选择批量通过一个');
        return false;
      }
      this.$confirm('是否批量通过工单?', '操作确认', {}).then(function () {
        _this.batchPass(multipleIds);
      }).catch(function (action) {
        console.log('取消批量通过操作');
      });
    },
    batchPass: function batchPass(multipleIds) {
      var _this2 = this;

      return request.common('batchSucceed', multipleIds).then(function (res) {
        var message = '批量通过，成功' + res.data.success.length + '个,共' + multipleIds.order_ids.length + '个';
        if (res.data.success.length < multipleIds.order_ids.length) {
          message += ',失败id' + res.data.success.join(',');
        }
        _this2.$message({
          showClose: true,
          message: message,
          type: 'success'
        });
        _this2.$emit('batchSucceed');
      });
    }
  }
});

/***/ }),

/***/ 1691:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_order_components_OrderResetProcessForm_vue__ = __webpack_require__(1770);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["b" /* default */]],
  props: {
    scope: Object
  },
  methods: {
    onLocked: function onLocked(scopeRow) {
      var _this = this;

      var orderid = scopeRow.orderid;
      if (orderid) {
        // 解锁：不需要原因
        if (scopeRow.locked === 1) {
          return request.alert('orderLocked', { orderid: orderid }).then(function () {
            _this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            });
            // 点击锁定 locked改为1，点击解锁改为10
            scopeRow.locked = 10;
          });
        }

        // 锁定：弹窗输入原因（可不填）
        return this.$prompt('锁单原因（可不填）', '锁定', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '例如：等待补充材料 / 异常数据核对中',
          inputType: 'textarea'
        }).then(function (_ref) {
          var value = _ref.value;

          return request.alert('orderLocked', {
            orderid: orderid,
            lock_reason: value == null ? '' : String(value).trim()
          }).then(function () {
            _this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            });
            scopeRow.locked = 1;
          });
        }).catch(function () {});
      }
    },
    onFinish: function onFinish(scopeRow) {
      var _this2 = this;

      var orderid = scopeRow.orderid;
      if (orderid) {
        this.$confirm('你确定要强制完成任务吗？').then(function (_) {
          request.alert('orderFinishEnforce', { orderid: orderid }).then(function (_ref2) {
            var data = _ref2.data;

            _this2.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            });
            scopeRow.status = 4;
          });
        }).catch(function (_) {});
      }
    },
    resetFinish: function resetFinish(scopeRow) {
      var _this3 = this;

      var orderid = scopeRow.orderid;
      if (orderid) {
        this.$confirm('你确定要重新置为待审核状态吗？').then(function (_) {
          request.alert('orderReset2Finish', { orderid: orderid }).then(function (_ref3) {
            var data = _ref3.data;

            _this3.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            });
            scopeRow.status = 4;
          });
        }).catch(function (_) {});
      }
    },
    resetProcess: function resetProcess(scopeRow) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var orderid, content, hours;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                orderid = scopeRow.orderid;

                if (!orderid) {
                  _context.next = 15;
                  break;
                }

                _context.prev = 2;
                content = _this4.$createElement(__WEBPACK_IMPORTED_MODULE_3__views_order_components_OrderResetProcessForm_vue__["a" /* default */]);
                hours = void 0;
                _context.next = 7;
                return _this4.$confirm(content, '重置进行中', {
                  closeOnClickModal: false,
                  beforeClose: function beforeClose(action, instance, done) {
                    if (action === 'confirm' && content.componentInstance) {
                      hours = content.componentInstance.getValue();
                    }
                    done();
                  }
                });

              case 7:
                _context.next = 9;
                return request.alert('orderReset2Process', { orderid: orderid, hours: hours });

              case 9:
                _this4.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success'
                });
                scopeRow.status = 3;
                _context.next = 15;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](2);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[2, 13]]);
      }))();
    },
    onWithdraw: function onWithdraw(scopeRow) {
      var _this5 = this;

      var orderid = scopeRow.orderid;
      if (orderid) {
        this.$confirm('是否确认收回？').then(function (_) {
          _this5.$confirm('是否需要补偿零豆?', '', {
            confirmButtonText: '是',
            cancelButtonText: '否'
          }).then(function (_) {
            request.alert('orderWithdraw', { orderid: orderid, needCompensation: true }).then(function (_ref4) {
              var data = _ref4.data;

              _this5.$message({
                showClose: true,
                message: '操作成功',
                type: 'success'
              });
              scopeRow.status = -1;
            });
          }).catch(function (_) {
            request.alert('orderWithdraw', { orderid: orderid, needCompensation: false }).then(function (_ref5) {
              var data = _ref5.data;

              _this5.$message({
                showClose: true,
                message: '操作成功',
                type: 'success'
              });
              scopeRow.status = -1;
            });
          });
        }).catch(function (_) {});
      }
    },
    canAuditOrderAppealBtn: function canAuditOrderAppealBtn(row) {
      // 处于申诉中，并且具有审核的UI权限
      return row.status * 1 === 20 && filter.hasPermission(40012);
    },
    canResetProcess: function canResetProcess(orderDetail) {
      return orderDetail.status * 1 === -1 && filter.hasPermission(40011);
    }
  }
});

/***/ }),

/***/ 1692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    visible: Boolean,
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      id: 0,
      form: {
        allowance: ''
      }
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ allowance: _this.form.allowance }, _this.info);
                _context.next = 4;
                return request.alert('executiveAllowanceApply', params).then(function (res) {
                  _this.$message.success('执行补贴申请发送成功');
                  _this.closeDialog();
                  _this.loading = false;
                }).catch(function () {
                  _this.loading = false;
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    closeDialog: function closeDialog() {
      this.$refs.form.resetFields();
      this.$emit('closeDialog');
    }
  }
});

/***/ }),

/***/ 1770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderResetProcessForm_vue__ = __webpack_require__(1596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a917bdf2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderResetProcessForm_vue__ = __webpack_require__(1771);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderResetProcessForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a917bdf2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderResetProcessForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"margin":"0 0 12px"}},[_vm._v("你确定要将已关闭工单重置为进行中吗？")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',{staticStyle:{"margin-right":"8px"}},[_vm._v("延长结束时间：")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"120px"},model:{value:(_vm.hours),callback:function ($$v) {_vm.hours=$$v},expression:"hours"}},_vm._l((_vm.hourOptions),function(val){return _c('el-option',{key:val,attrs:{"label":(val + " 小时"),"value":val}})}),1)],1),_vm._v(" "),_c('p',{staticStyle:{"margin":"8px 0 0","color":"#F56C6C","font-size":"12px","line-height":"1.4"}},[_vm._v("\n    延长工单时间将最晚不会超过当天23:59:59\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchSucceedButton_vue__ = __webpack_require__(1601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c4ebeb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchSucceedButton_vue__ = __webpack_require__(1773);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchSucceedButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c4ebeb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchSucceedButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1773:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"danger","size":"mini","disabled":_vm.batchid < 1},on:{"click":_vm.onSubmit}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchWithdrawButton_vue__ = __webpack_require__(1602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f84842_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchWithdrawButton_vue__ = __webpack_require__(1775);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchWithdrawButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f84842_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchWithdrawButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"danger","disabled":_vm.batchid < 1,"size":"mini"},on:{"click":_vm.onSubmit}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchCheckButton_vue__ = __webpack_require__(1603);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_519efb16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchCheckButton_vue__ = __webpack_require__(1784);
function injectStyle (ssrContext) {
  __webpack_require__(1777)
  __webpack_require__(1779)
  this["$style"] = __webpack_require__(1781)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-519efb16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOnBatchCheckButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_519efb16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOnBatchCheckButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1777:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1778);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("76124ede", content, true, {});

/***/ }),

/***/ 1778:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderOnBatchCheckButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1779:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1780);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7602f3c7", content, true, {});

/***/ }),

/***/ 1780:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".image-list .image-drop-shadow[data-v-519efb16]{padding:5px;border:1px solid #efefef}.image-list a[data-v-519efb16]{margin-right:10px;margin-bottom:10px}.image-list a:hover img.image-drop-shadow[data-v-519efb16]{border:1px solid #ccc;-webkit-box-shadow:1px 1px 5px #999;box-shadow:1px 1px 5px #999}", "", {"version":3,"sources":["/workspace/src/views/order/components/buttons/OrderOnBatchCheckButton.vue"],"names":[],"mappings":"AACA,gDAAgD,YAAY,wBAAwB,CACnF,AACD,+BAA+B,kBAAkB,kBAAkB,CAClE,AACD,2DAA2D,sBAAsB,oCAAoC,2BAA2B,CAC/I","file":"OrderOnBatchCheckButton.vue","sourcesContent":["\n.image-list .image-drop-shadow[data-v-519efb16]{padding:5px;border:solid 1px #EFEFEF\n}\n.image-list a[data-v-519efb16]{margin-right:10px;margin-bottom:10px\n}\n.image-list a:hover img.image-drop-shadow[data-v-519efb16]{border:solid 1px #CCC;-webkit-box-shadow:1px 1px 5px #999;box-shadow:1px 1px 5px #999\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1781:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1782);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c447d096", content, true, {});

/***/ }),

/***/ 1782:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderOnBatchCheckButton.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchRules */
/* unused harmony export formRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return batchRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的工单ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入工单名称', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入至少2个字符', 'string'), { min: 2 })]
};

var batchRules = {
  file: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传文件', 'object'))],
  starttime: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择时间'))],
  orderid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入工单id', 'integer'))]
};

/***/ }),

/***/ 1784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-button',{attrs:{"size":"mini","type":"warning","disabled":_vm.batchid < 1},on:{"click":function($event){_vm.dialogFormVisible = true}}},[_vm._t("default")],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"按批次审核","visible":_vm.dialogFormVisible},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.batchRules}},[_c('el-form-item',{attrs:{"label":"上传Excel","prop":"file","label-width":"120px"}},[_c('el-upload',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"uploadThumb",staticClass:"re-el-upload-width-max",attrs:{"drag":"","multiple":false,"limit":1,"action":"","before-upload":_vm.beforeAvatarUpload,"accept":".xlsx,.xls","http-request":_vm.uploadRequest}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击选择文件")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",staticStyle:{"margin-top":"0"},attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能选择Microsoft Office Excel文件，且不超过2048kb\n        ")])])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开始时间","label-width":"120px","prop":"starttime"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"选择日期时间","value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.form.starttime),callback:function ($$v) {_vm.$set(_vm.form, "starttime", $$v)},expression:"form.starttime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工单ID","prop":"orderid","label-width":"120px"}},[_c('el-input',{attrs:{"placeholder":"请输入工单id"},model:{value:(_vm.form.orderid),callback:function ($$v) {_vm.$set(_vm.form, "orderid", $$v)},expression:"form.orderid"}})],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"width":"50%","title":"提示","visible":_vm.innerVisible,"append-to-body":""},on:{"update:visible":function($event){_vm.innerVisible=$event}}},[_c('span',[_vm._v("按批次审核是否需要检测?")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.onDetection}},[_vm._v("不需要")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("需要")])],1)]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onOpenInner}},[_vm._v("确 定\n    ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2017:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderBatchSucceedButton_vue__ = __webpack_require__(1690);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45305659_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderBatchSucceedButton_vue__ = __webpack_require__(2018);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderBatchSucceedButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45305659_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderBatchSucceedButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"disabled":_vm.multipleSelection.length > 0,"content":"请勾选工单前的数据多选框","placement":"top","effect":"dark"}},[_c('el-button',{attrs:{"type":"danger","size":"mini","disabled":_vm.multipleSelection.length <= 0},on:{"click":_vm.onSubmit}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOperationButtons_vue__ = __webpack_require__(1691);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7361de8d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOperationButtons_vue__ = __webpack_require__(2020);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderOperationButtons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7361de8d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderOperationButtons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button-gutter',[(_vm.scope.row.type !== 127)?[(_vm.scope.row.locked === 1 && (_vm.scope.row.status === 4 || _vm.scope.row.status === 40 ))?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.onLocked(_vm.scope.row)}}},[_vm._v("解锁\n    ")]):_vm._e(),_vm._v(" "),((_vm.scope.row.locked === 0 || _vm.scope.row.locked === 10) && (_vm.scope.row.status === 4 || _vm.scope.row.status === 40))?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.onLocked(_vm.scope.row)}}},[_vm._v("锁定\n    ")]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":'/order/review/'+_vm.scope.row.orderid,"target":"_blank"}},[((_vm.scope.row.status !== 4))?_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v("查看\n      ")]):_vm._e()],1),_vm._v(" "),_c('router-link',{attrs:{"to":'/order/review/'+_vm.scope.row.orderid,"target":"_blank"}},[(_vm.scope.row.status === 4)?_c('el-button',{attrs:{"size":"mini"}},[_vm._v("审核\n      ")]):_vm._e(),_vm._v(" "),(_vm.scope.row.status === 5 && _vm.scope.row.type !== 8)?_c('el-button',{staticStyle:{"margin-top":"6px"},attrs:{"size":"mini"}},[_vm._v("修改审核\n      ")]):_vm._e()],1),_vm._v(" "),(_vm.scope.row.status === 4)?_c('router-link',{attrs:{"to":'/order/review/'+_vm.scope.row.orderid + '?readonly=on',"target":"_blank"}},[_c('el-button',{attrs:{"size":"mini"}},[_vm._v("查看")])],1):_vm._e(),_vm._v(" "),(_vm.canAuditOrderAppealBtn(_vm.scope.row))?_c('router-link',{attrs:{"to":'/order/appeal/review-order/'+_vm.scope.row.orderid,"target":"_blank"}},[_c('el-button',{attrs:{"size":"mini","type":"primary"}},[_vm._v("处理申诉")])],1):_vm._e(),_vm._v(" "),((_vm.scope.row.status === 2 || _vm.scope.row.status === 3))?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onWithdraw(_vm.scope.row)}}},[_vm._v("收回\n    ")]):_vm._e(),_vm._v(" "),(_vm.scope.row.status === 3 && _vm.scope.row.type !== 19)?_c('el-button',{staticStyle:{"margin-top":"6px"},attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onFinish(_vm.scope.row)}}},[_vm._v("强制完成\n    ")]):_vm._e(),_vm._v(" "),(_vm.canResetProcess(_vm.scope.row))?_c('el-button',{staticStyle:{"margin-top":"6px"},attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.resetProcess(_vm.scope.row)}}},[_vm._v("重置进行中\n    ")]):_vm._e(),_vm._v(" "),((_vm.scope.row.status === -1) || _vm.scope.row.status === -2)?_c('el-button',{staticStyle:{"margin-top":"6px"},attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.resetFinish(_vm.scope.row)}}},[_vm._v("重置待审核\n    ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.scope.row.type === 127)?_c('router-link',{attrs:{"to":("/order/md/table/" + (_vm.scope.row.taskid))}},[_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v("查看包含工单\n         ")])],1):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2021:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderAllowanceDialog_vue__ = __webpack_require__(1692);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b25c8bde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderAllowanceDialog_vue__ = __webpack_require__(2028);
function injectStyle (ssrContext) {
  __webpack_require__(2022)
  __webpack_require__(2024)
  this["$style"] = __webpack_require__(2026)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b25c8bde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderAllowanceDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b25c8bde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderAllowanceDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2022:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2023);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6afabe4b", content, true, {});

/***/ }),

/***/ 2023:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderAllowanceDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2024:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2025);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("9ef741c6", content, true, {});

/***/ }),

/***/ 2025:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderAllowanceDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2026:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2027);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("ed8f06d6", content, true, {});

/***/ }),

/***/ 2027:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderAllowanceDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"用户补贴","visible":_vm.visible,"before-close":_vm.closeDialog,"width":"500px"}},[_c('div',{staticStyle:{"text-align":"center","font-size":"20px"}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"项目ID","prop":"name"}},[_vm._v("\n            "+_vm._s(_vm.info.projectid)+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"用户ID","prop":"name"}},[_vm._v("\n            "+_vm._s(_vm.info.userid)+"\n          ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属省份","prop":"name"}},[_vm._v("\n            "+_vm._s(_vm.info.province_name)+"\n          ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"可用金额","prop":"name"}},[_vm._v("\n            "+_vm._s(_vm.info.remain_amount)+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"补贴金额","prop":"name"}},[_c('el-input',{model:{value:(_vm.form.allowance),callback:function ($$v) {_vm.$set(_vm.form, "allowance", $$v)},expression:"form.allowance"}})],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("确定\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("取消")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_OrderSearch__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_buttons_OrderBatchSucceedButton__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_OrderOnBatchSucceedButton__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_buttons_OrderOnBatchWithdrawButton__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_buttons_OrderOnBatchCheckButton__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_order_components_buttons_OrderOperationButtons__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_task_components_buttons_TaskDescButton__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_order_components_OrderAllowanceDialog__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_common__ = __webpack_require__(1515);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












// 这里的 key 必须和后端 ExportOrderNewHandler 的字段 key 一致。
// 不能使用中文标题作为传参值，因为标题可能会随着导出格式或单位发生变化。
var ORDER_EXPORT_FIELD_OPTIONS = [{ key: 'orderid', label: '工单ID' }, { key: 'taskid', label: '任务ID' }, { key: 'title', label: '任务标题' }, { key: 'type', label: '任务类型' }, { key: 'salary', label: '赏金' }, { key: 'dynamic_adjust_salary', label: '调价幅度' }, { key: 'realsalary', label: '工单结算金额' }, { key: 'points', label: '零豆' }, { key: 'validcheckindistance', label: '有效签到距离' }, { key: 'outrange_times', label: '出签到范围次数' }, { key: 'interrupted_times', label: '重新签到次数' }, { key: 'lastupdatetimeadmin', label: '管理员更新时间' }, { key: 'showtime', label: '任务浏览开始时间' }, { key: 'starttime', label: '任务上线时间' }, { key: 'deadline', label: '任务下线时间' }, { key: 'taskendtime', label: '任务结束时间' }, { key: 'publishtime', label: '任务发布时间' }, { key: 'uservietime', label: '用户抢单时间' }, { key: 'userstarttime', label: '用户开始时间' }, { key: 'userfinishtime', label: '用户结束时间' }, { key: 'start_app_type', label: '签到平台' }, { key: 'finish_app_type', label: '提交平台' }, { key: 'sec_consumed', label: '做单时长' }, { key: 'first_order_duration', label: '首次做单时长' }, { key: 'processingtime', label: '任务完成时限(h)' }, { key: 'reviewtime', label: '审单时间(d)' }, { key: 'reviewedtime', label: '审核完成时间' }, { key: 'adminname', label: '添加管理员' }, { key: 'first_reviewer', label: '初审管理员' }, { key: 'content', label: '任务详细描述' }, { key: 'provinceid', label: '省份' }, { key: 'cityid', label: '城市' }, { key: 'areaid', label: '地区' }, { key: 'marketid', label: '任务所属商场' }, { key: 'marketaddress', label: '门店地址' }, { key: 'taskmarketareaid', label: '任务所在区域' }, { key: 'photo', label: '任务照片' }, { key: 'photocert', label: '任务完成后照片证据' }, { key: 'checkinlongitude', label: '任务签到经度' }, { key: 'checkinlatitude', label: '任务签到纬度' }, { key: 'finishlongitude', label: '任务完成后经度' }, { key: 'finishlatitude', label: '任务完成后纬度' }, { key: 'hirenum', label: '需要人数' }, { key: 'customerid', label: '客户编号' }, { key: 'projectid', label: '项目编号' }, { key: 'batchid', label: '批次名称/ID' }, { key: 'templateid', label: '分步模板ID' }, { key: 'userid', label: '完成人ID' }, { key: 'gpsCheck', label: 'GPS位置验证' }, { key: 'superuserprior', label: '是否白金用户优先' }, { key: 'rejecttaskrepeat', label: '退单后任务可重复执行' }, { key: 'rejectuserrepeat', label: '退单后用户可修改' }, { key: 'priority', label: '是否置顶' }, { key: 'multitimes', label: '是否可以多次接单' }, { key: 'onlynearby', label: '是否不在任务大厅显示' }, { key: 'review', label: '审核次数' }, { key: 'errormessage', label: '任务审核不通过原因' }, { key: 'strstatus', label: '任务状态' }, { key: 'appointuserid', label: '定向用户' }, { key: 'whitelist', label: '白名单' }, { key: 'whitelisttags', label: '白名单标签' }, { key: 'blacklist', label: '黑名单' }, { key: 'blacklisttags', label: '黑名单标签' }, { key: 'ostype', label: '发布平台' }, { key: 'platformtype', label: '发布App' }, { key: 'minclientversionforandroid', label: '安卓客户端最低版本' }, { key: 'minclientversionforios', label: 'IOS客户端最低版本' }, { key: 'minclientversionforandroid_clb', label: '查理宝安卓客户端最低版本' }, { key: 'minclientversionforios_clb', label: '查理宝IOS客户端最低版本' }, { key: 'reviewerid', label: '审核管理员' }, { key: 'total_order_audit_duration', label: '审单时长' }, { key: 'devicenum', label: '设备号' }, { key: 'use_servercache', label: '服务器缓存' }, { key: 'personface_verify', label: '人脸验证' }, { key: 'face_verified_times', label: '人脸验证次数' }, { key: 'img_count', label: '照片总数' }, { key: 'need_full_workinfo', label: '限已完善职业信息用户抢单' }, { key: 'sneak_photos', label: '前置镜头抓拍' }, { key: 'vie_source', label: '抢单渠道' }, { key: 'rank_score', label: '打分分数' }];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_table_v3__["a" /* default */]],
  components: {
    OrderSearch: __WEBPACK_IMPORTED_MODULE_4__components_OrderSearch__["a" /* default */],
    OrderBatchSucceedButton: __WEBPACK_IMPORTED_MODULE_5__components_buttons_OrderBatchSucceedButton__["a" /* default */],
    OrderOnBatchSucceedButton: __WEBPACK_IMPORTED_MODULE_6__components_buttons_OrderOnBatchSucceedButton__["a" /* default */],
    OrderOnBatchWithdrawButton: __WEBPACK_IMPORTED_MODULE_7__components_buttons_OrderOnBatchWithdrawButton__["a" /* default */],
    OrderOnBatchCheckButton: __WEBPACK_IMPORTED_MODULE_8__components_buttons_OrderOnBatchCheckButton__["a" /* default */],
    OrderOperationButtons: __WEBPACK_IMPORTED_MODULE_9__views_order_components_buttons_OrderOperationButtons__["a" /* default */],
    TaskDescButton: __WEBPACK_IMPORTED_MODULE_10__views_task_components_buttons_TaskDescButton__["a" /* default */],
    OrderAllowanceDialog: __WEBPACK_IMPORTED_MODULE_11__views_order_components_OrderAllowanceDialog__["a" /* default */]
  },
  data: function data() {
    return {
      table: [],
      exportType: this.$route.query.export_type || 'order_new',
      multipleSelection: [],
      dialogVisible: false,
      dialogBatchVisible: false,
      dialogAllowanceVisible: false,
      dialogSneakSimilarVisible: false,
      dialogExchangeOrderVisible: false,
      dialogExportFieldVisible: false,
      exportFieldTarget: '',
      exportFieldOptions: ORDER_EXPORT_FIELD_OPTIONS,
      // 默认全选基础字段，用户可以在弹窗中取消不需要的字段。
      // 这样不会因为误确认空数组而触发后端的旧版全量导出。
      exportField: ORDER_EXPORT_FIELD_OPTIONS.map(function (field) {
        return field.key;
      }),
      // 题目证据沿用旧版 only_basic 开关，不作为普通 exportField 传递。
      exportQuestionEvidence: false,
      exportCount: 0,
      search: {
        reactive_by_user: null,
        platformtype: null, // 平台类型
        onlineRange: [],
        offlineRange: [],
        reformat: 1,
        start_begin: null,
        start_end: null,
        endtime_begin: null,
        endtime_end: null,
        customerid: null,
        projectid: [],
        start_app_type: [],
        finish_app_type: [],
        type: null,
        batchid: [],
        status: [],
        templateid: null,
        addto_taskgroup_target_num: null,
        userid: null,
        query_areas: [],
        finish_query_areas: [],
        taskmarketareaid: null,
        marketname: null,
        locked: null,
        text: null,
        review_begin: null,
        review_end: null,
        sort_by_review: null,
        sort_by_lastupdatetime: null,
        sort_by_endtime: null,
        userfinishtime: [],
        first_reviewerid: null,
        taskid: null,
        not_type: [21] // 默认排除 线上检查任务, 即PlanC任务
      },
      // 搜索字段申明
      searchFieldType: {
        type: Number,
        status: Array,
        query_areas: Array,
        finish_query_areas: Array,
        start_app_type: __WEBPACK_IMPORTED_MODULE_12__utils_common__["a" /* NumberArray */],
        finish_app_type: __WEBPACK_IMPORTED_MODULE_12__utils_common__["a" /* NumberArray */],
        locked: Number,
        review_begin: Number,
        review_end: Number,
        taskmarketareaid: Number,
        addto_taskgroup_target_num: Number,
        reactive_by_user: Number
      },
      exportAsync: false,
      convert_midan_task: false,
      dashboardFormat: false,
      exchangeOrderForm: {
        orderid1: null,
        orderid2: null
      },
      allowanceInfo: {
        order_ids: [],
        provinceid: 0,
        projectid: 0,
        userid: 0,
        remain_amount: 0
      }
    };
  },

  computed: Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    },
    users: function users(state) {
      return state.login.user;
    }
  }),
  methods: {
    formatPlatform: function formatPlatform(row, column, cellValue, index) {
      if (cellValue === 0) {
        return row[column.property === 'start_app_type' ? 'userstarttime' : 'userfinishtime'] ? '爱零工' : '';
      }
      var matchedItem = this.options.app_type_list.find(function (item) {
        return item.value === cellValue;
      });

      // 如果找到了就返回 label，没找到就返回 '未知'
      return matchedItem ? matchedItem.label : '-';
    },

    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getOrderTable', params);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchSucceed: function batchSucceed() {
      this.$refs.multipleTable.clearSelection();
      this.onSearch();
    },
    sortChange: function sortChange(column, prop, order) {
      var sortBy = 'asc';
      if (column.order === 'descending') {
        sortBy = 'desc';
      }
      if (column.prop === 'review') {
        this.search.sort_by_review = sortBy;
      } else if (column.prop === 'lastupdatetime') {
        this.search.sort_by_lastupdatetime = sortBy;
      } else if (column.prop === 'endtime') {
        this.search.sort_by_endtime = sortBy;
      }
      this.onSearch();
    },
    onExportPage: function onExportPage(onlyBasic, dashboardFormat) {
      var exportField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      this.dialogVisible = false;
      var multipleIds = {
        orderid: this.multipleSelection.map(function (item) {
          return item.orderid;
        }),
        export_type: this.exportType,
        only_basic: onlyBasic,
        export_async: this.exportAsync,
        dashboard_format: dashboardFormat,
        convert_midan_task: this.convert_midan_task,
        exportField: exportField
      };

      if (multipleIds.orderid.length <= 0) {
        this.$message.error('请至少选择批量导出一个');
        return false;
      }

      if (this.exportAsync) {
        return this.onExportAsync(multipleIds);
      }

      this.$export(this.$route.meta.title + '-' + this.pagination.current_page + 'P', {
        fileHeader: this.exportHeader,
        total: multipleIds.orderid.length,
        request: function (_request) {
          function request(_x2) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request('exportOrder', params);
        }),
        requestParams: multipleIds,
        fileType: 'csv',
        type: 'array',
        getResponseData: function getResponseData(data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    },
    onExportSearch: function onExportSearch(onlyBasic, dashboardFormat) {
      var exportField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      this.dialogBatchVisible = false;
      var detail = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.search, {
        only_basic: onlyBasic,
        export_type: this.exportType,
        export_async: this.exportAsync,
        dashboard_format: dashboardFormat,
        convert_midan_task: this.convert_midan_task,
        exportField: exportField
      });

      if (this.exportAsync) {
        return this.onExportAsync(detail);
      }

      this.$export(this.$route.meta.title + '-' + this.pagination.current_page + 'P', {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: function (_request2) {
          function request(_x4) {
            return _request2.apply(this, arguments);
          }

          request.toString = function () {
            return _request2.toString();
          };

          return request;
        }(function (params) {
          return request('exportOrder', params);
        }),
        requestParams: detail,
        fileType: 'csv',
        type: 'array',
        getResponseData: function getResponseData(data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    },
    onExportAsync: function onExportAsync(detail) {
      var _this = this;

      return request.common('exportOrder', detail).then(function () {
        return _this.$message.success('创建成功，请在任务管理中心查看！');
      });
    },
    onExportLowScoreFaceImg: function onExportLowScoreFaceImg() {
      var _this2 = this;

      var detail = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.search);
      if (detail.projectid.length < 1 && detail.batchid.length < 1) {
        this.$alert('请选择项目或批次后再进行数据导出');
        return;
      }

      this.$confirm('确认要导出所有有得分的人脸验证照片吗?', '提示', { type: 'warning' }).then(function () {
        return request.common('exportOrderLowScoreFaceImgApi', detail).then(function () {
          return _this2.$message.success('任务创建成功，请在任务管理中心查看！');
        });
      });
    },
    showExchangeOrderDialog: function showExchangeOrderDialog() {
      this.$set(this, 'exchangeOrderForm', {
        orderid1: null,
        orderid2: null
      });
      this.dialogExchangeOrderVisible = true;
    },
    closeExchangeOrderDialog: function closeExchangeOrderDialog() {
      this.dialogExchangeOrderVisible = false;
    },
    showExportSneakSimilarityDialog: function showExportSneakSimilarityDialog() {
      this.exportCount = this.pagination.total;
      this.dialogSneakSimilarVisible = true;
    },
    countDown: function countDown(date) {
      var futureTs = (Date.parse(date) + '').substr(0, 10);
      var currentTs = (new Date().getTime() + '').substr(0, 10);
      var interval = futureTs - currentTs;

      if (interval < 0) {
        return '';
      }

      return filter.formatTimerHumanize(interval);
    },
    showExportDialog: function showExportDialog() {
      this.dialogVisible = true;
      this.exportAsync = false;
      this.convert_midan_task = false;
    },
    showExportSearchDialog: function showExportSearchDialog() {
      this.dialogBatchVisible = true;
      this.exportAsync = false;
      this.convert_midan_task = false;
    },
    showExportFieldDialog: function showExportFieldDialog(target) {
      // 记录用户是从“已选工单”还是“搜索结果”打开字段选择。
      // 确认后会回到对应的导出方法，两个弹窗共用这一套字段选择逻辑。
      this.exportFieldTarget = target;
      this.dialogExportFieldVisible = true;
    },

    /**
     * 全选导出字段。
     *
     * 通过字段配置重新生成数组，而不是直接复用当前 exportField，
     * 这样无论用户之前取消了哪些字段，点击“全选”后都能恢复完整字段列表。
     */
    selectAllExportFields: function selectAllExportFields() {
      this.exportField = this.exportFieldOptions.map(function (field) {
        return field.key;
      });
    },

    /**
     * 取消全选导出字段。
     *
     * 清空 exportField 后，所有字段复选框都会取消选中；
     * 后续点击“确认导出”时会提示用户至少选择一列。
     */
    clearExportFields: function clearExportFields() {
      this.exportField = [];
    },
    confirmExportFieldSelection: function confirmExportFieldSelection() {
      if (this.exportField.length === 0) {
        this.$message.error('请至少选择一列导出');
        return;
      }

      this.dialogExportFieldVisible = false;

      // 勾选“所有题目证据”时，沿用旧版 only_basic=0；
      // 未勾选时使用 only_basic=1，只导出所选基础字段。
      var onlyBasic = this.exportQuestionEvidence ? 0 : 1;
      var exportField = this.exportField.slice();

      if (this.exportFieldTarget === 'page') {
        return this.onExportPage(onlyBasic, 0, exportField);
      }

      return this.onExportSearch(onlyBasic, 0, exportField);
    },
    showAllowanceDialog: function showAllowanceDialog() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var multipleIds, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                multipleIds = {
                  orderid: _this3.multipleSelection.map(function (item) {
                    return item.orderid;
                  })
                };

                if (!(multipleIds.orderid.length <= 0)) {
                  _context.next = 4;
                  break;
                }

                _this3.$message.error('请至少选择一个工单');
                return _context.abrupt('return', false);

              case 4:
                if (_this3.multipleSelection.every(function (v) {
                  return v.provinceid === _this3.multipleSelection[0].provinceid;
                })) {
                  _context.next = 7;
                  break;
                }

                _this3.$message.error('工单省份不一致');
                return _context.abrupt('return', false);

              case 7:
                params = {
                  order_ids: multipleIds.orderid,
                  provinceid: _this3.multipleSelection[0].provinceid,
                  province_name: _this3.multipleSelection[0].provincename,
                  projectid: _this3.getFirstSearchProjectId(),
                  userid: _this3.search.userid
                };

                _this3.allowanceInfo = params;
                _context.next = 11;
                return request.common('getExecutiveAllowance', params).then(function (data) {
                  _this3.allowanceInfo.remain_amount = data.data ? data.data : 0;
                });

              case 11:

                _this3.dialogAllowanceVisible = true;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    salaryValue: function salaryValue(value) {
      return filter.hasPermission(250) ? value : '*';
    },
    getFirstSearchProjectId: function getFirstSearchProjectId() {
      if (this.search.projectid.length !== 1) {
        return '-1';
      }
      return _.first(this.search.projectid);
    },
    getFirstSearchBatchId: function getFirstSearchBatchId() {
      if (this.search.projectid.length !== 1 || this.search.batchid.length !== 1) {
        return '-1';
      }
      return _.first(this.search.batchid);
    },
    onExportOrderSneakSimilarity: function onExportOrderSneakSimilarity() {
      var _this4 = this;

      var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.search, {
        convert_midan_task: this.convert_midan_task
      });
      request.common('exportOrderSneakSimilarity', params).then(function (data) {
        _this4.$confirm('抓拍相似度导出任务创建成功，请是否前往批量任务列表中查看?', '提示', { type: 'success' }).then(function () {
          _this4.$router.push({ path: '/task/batch/table' });
        });
      });
    },
    doExchangeOrder: function doExchangeOrder() {
      var _this5 = this;

      var params = _.cloneDeep(this.exchangeOrderForm);
      this.$confirm('\u786E\u5B9A\u8981\u4EA4\u6362\u5DE5\u53551 (' + params.orderid1 + ') \u4E0E\u5DE5\u53552 (' + params.orderid2 + ') \u7684\u53D6\u8BC1\u6570\u636E\u5417\uFF1F', '操作提示', { type: 'info' }).then(function () {
        request.common('allowExchangeOrderApi', params).then(function (_ref) {
          var data = _ref.data;

          // canExchange 是否允许交换，false 代表不允许
          if (data.canExchange === false) {
            // canForceExchange 是否允许强制交换, true 允许强制交换,false 不允许
            // 目前规则下,宴席类的工单在使用模板ID不一致的场景下，允许强制交换数据
            if (data.canForceExchange === true) {
              _this5.$confirm(data.msg + ', <strong style="color: red;">\u786E\u5B9A\u8981\u7EE7\u7EED\u5F3A\u5236\u4EA4\u6362\u5DE5\u5355\u6570\u636E\u5417\uFF1F</strong>', '强制交换数据提示', { type: 'warning', dangerouslyUseHTMLString: true }).then(function () {
                _this5.callExchangeOrderApi(params);
              }).catch(function () {});
            } else {
              _this5.$alert('' + data.msg, '禁止交换工单', { type: 'error' });
            }
          } else if (data.canExchange === true) {
            _this5.callExchangeOrderApi(params);
          }
        }).catch(function () {});
      });
    },
    callExchangeOrderApi: function callExchangeOrderApi(params) {
      var _this6 = this;

      request.common('exchangeOrderApi', params).then(function (_ref2) {
        var data = _ref2.data;

        _this6.$message.success('数据交换成功');
        _this6.closeExchangeOrderDialog();
      });
    }
  }
});

/***/ }),

/***/ 2840:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_task_task_mixins__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_area_components_ContainmentAreaCascader__ = __webpack_require__(1600);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_2__views_task_task_mixins__["a" /* default */]],
  components: {
    ContainmentAreaCascader: __WEBPACK_IMPORTED_MODULE_3__views_area_components_ContainmentAreaCascader__["a" /* default */]
  },
  data: function data() {
    return {
      search: {
        starttime: null,
        endtime: null,
        lastupdatetime: null,
        type: null,
        projectid: [],
        batchid: [],
        status: [],
        taskmarketareaid: null,
        userid: null,
        title: null,
        query_areas: []
      },
      searchFieldType: {
        type: Number,
        status: Array,
        locked: Number,
        review_begin: Number,
        review_end: Number,
        templateid: Number,
        taskmarketareaid: Number,
        query_areas: Array
      },
      dialogBatchVisible: false,
      exportAsync: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapGetters('order', ['getSortedTaskTypes'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail']), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.page('getOrderArchivedTable', params);
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.search.query_areas = [];
    },
    projectIdChanged: function projectIdChanged() {
      if (this.search.batchid.length > 0) {
        this.search.batchid = [];
      }
    },
    onExportSearch: function onExportSearch(onlyBasic) {
      this.dialogBatchVisible = false;
      var detail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.search, {
        only_basic: onlyBasic,
        export_async: this.exportAsync,
        dashboard_format: false,
        convert_midan_task: false
      });

      if (this.exportAsync) {
        return this.onExportAsync(detail);
      }

      this.$export(this.$route.meta.title + '-' + this.pagination.current_page + 'P', {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: function (_request) {
          function request(_x) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request('exportOrderArchived', params);
        }),
        requestParams: detail,
        fileType: 'csv',
        type: 'array',
        getResponseData: function getResponseData(data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    },
    showExportSearchDialog: function showExportSearchDialog() {
      this.dialogBatchVisible = true;
      this.exportAsync = false;
    },
    onExportAsync: function onExportAsync(detail) {
      var _this = this;

      return request.common('exportOrderArchived', detail).then(function () {
        return _this.$message.success('创建成功，请在任务管理中心查看！');
      });
    }
  })
});

/***/ }),

/***/ 4794:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4795);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("30ad2ad8", content, true, {});

/***/ }),

/***/ 4795:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".el-dialog .el-checkbox[data-v-e97b5cac]{white-space:normal}.el-dialog .el-checkbox[data-v-e97b5cac] .el-checkbox__label{display:inline}.export-field-actions[data-v-e97b5cac]{margin-bottom:12px}.export-field-list[data-v-e97b5cac]{max-height:420px;overflow-y:auto;margin-bottom:18px}.export-field-list .el-checkbox[data-v-e97b5cac]{width:100%;margin:0 0 12px}", "", {"version":3,"sources":["/workspace/src/views/order/pages/OrderTable.vue"],"names":[],"mappings":"AACA,yCAAyC,kBAAkB,CAC1D,AACD,6DAA6D,cAAc,CAC1E,AACD,uCAAuC,kBAAkB,CACxD,AACD,oCAAoC,iBAAiB,gBAAgB,kBAAkB,CACtF,AACD,iDAAiD,WAAW,eAAe,CAC1E","file":"OrderTable.vue","sourcesContent":["\n.el-dialog .el-checkbox[data-v-e97b5cac]{white-space:normal\n}\n.el-dialog .el-checkbox[data-v-e97b5cac] .el-checkbox__label{display:inline\n}\n.export-field-actions[data-v-e97b5cac]{margin-bottom:12px\n}\n.export-field-list[data-v-e97b5cac]{max-height:420px;overflow-y:auto;margin-bottom:18px\n}\n.export-field-list .el-checkbox[data-v-e97b5cac]{width:100%;margin:0 0 12px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("工单管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('TaskDescButton')],1)],1),_vm._v(" "),_c('order-search',{attrs:{"showPlatformSearch":true,"show-addto-taskgroup-target-num":"","searchValue":_vm.search},on:{"onSearch":_vm.onSearch}}),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"sj-icon-export"},on:{"click":_vm.showExportDialog}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.showExportDialog}},[_vm._v("批量导出\n      ")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"primary","size":"mini"},on:{"click":_vm.showExportSearchDialog}},[_vm._v("按搜索结果导出\n      ")]),_vm._v(" "),_c('order-batch-succeed-button',{staticStyle:{"margin-left":"10px"},attrs:{"multipleSelection":_vm.multipleSelection},on:{"batch-succeed":_vm.batchSucceed}},[_vm._v("\n        批量通过\n      ")]),_vm._v(" "),_c('el-button',{directives:[{name:"permission",rawName:"v-permission",value:(265),expression:"265"}],attrs:{"type":"primary","size":"mini"},on:{"click":_vm.showExportSneakSimilarityDialog}},[_vm._v("前置抓拍对比导出\n      ")]),_vm._v(" "),(_vm.users.usertype + '' === '1')?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":_vm.onExportLowScoreFaceImg}},[_vm._v("人脸识别分值导出\n      ")]):_vm._e(),_vm._v(" "),_c('el-button',{directives:[{name:"permission",rawName:"v-permission",value:(268),expression:"268"}],attrs:{"type":"danger","size":"mini"},on:{"click":_vm.showExchangeOrderDialog}},[_vm._v("交换工单数据\n      ")]),_vm._v(" "),(_vm.search.batchid.length > 0)?[_c('el-tooltip',{attrs:{"disabled":_vm.getFirstSearchBatchId() > 0,"content":"请确保搜索条件中的 项目、批次 的已选条目个数均为 1 个","placement":"top","effect":"dark"}},[_c('span',[_c('order-on-batch-check-button',{staticStyle:{"margin-left":"10px"},attrs:{"batchid":_vm.getFirstSearchBatchId()}},[_vm._v("\n              按批次审核\n            ")]),_vm._v(" "),_c('order-on-batch-succeed-button',{staticStyle:{"margin-left":"10px"},attrs:{"batchid":_vm.getFirstSearchBatchId()}},[_vm._v("\n              按批次通过\n            ")]),_vm._v(" "),_c('order-on-batch-withdraw-button',{staticStyle:{"margin-left":"10px"},attrs:{"batchid":_vm.getFirstSearchBatchId()}},[_vm._v("\n              按批次收回\n            ")])],1)])]:_vm._e(),_vm._v(" "),(_vm.search.projectid.length > 0 && _vm.search.userid > 0)?_c('el-tooltip',{attrs:{"content":"请确保搜索条件中的 项目 的已选条目个数为 1 个","disabled":_vm.getFirstSearchProjectId() > 0,"placement":"top","effect":"dark"}},[_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"disabled":_vm.getFirstSearchProjectId() < 1,"type":"primary","size":"mini"},on:{"click":_vm.showAllowanceDialog}},[_vm._v("执行补贴\n        ")])],1):_vm._e()],2),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""},on:{"selection-change":_vm.handleSelectionChange,"sort-change":_vm.sortChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"orderid","width":"116px","label":"工单ID"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          ORD"+_vm._s(scope.row.orderid)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"任务标题"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/order/detail/'+scope.row.orderid}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v(_vm._s(scope.row.title))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"任务类型","width":"51px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.allType),function(item){return (scope.row.type === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"start_app_type","label":"签到平台","formatter":_vm.formatPlatform}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"finish_app_type","label":"提交平台","formatter":_vm.formatPlatform}}),_vm._v(" "),(parseInt(_vm.users.usertype) !== 3)?_c('el-table-column',{attrs:{"prop":"userid","label":"完成人","width":"84px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.userid !== 0)?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/users/table?keyword='+scope.row.userid}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v(_vm._s(scope.row.userid))])]):_vm._e()]}}],null,false,2027121702)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"赏金","width":"65px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.salaryValue(scope.row.salary))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"任务时间","width":"94px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.starttime)),_c('br'),_vm._v(_vm._s(scope.row.endtime)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"城市","width":"162px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.provincename)+_vm._s(scope.row.cityname)+_vm._s(scope.row.areaname)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"用户提交位置","width":"162px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.finish_provincename)+_vm._s(scope.row.finish_cityname)+_vm._s(scope.row.finish_areaname)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marketname","label":"门店名称"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":'/market/table?id='+scope.row.marketid,"target":"_blank"}},[_vm._v("\n            "+_vm._s(_vm._f("sjfmarketname")(scope.row.marketname,scope.row.type))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"任务状态","width":"92px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.status),function(item){return (scope.row.status === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"isInAudit","label":"审核状态","width":"92px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.isInAudit),function(item){return (scope.row.isInAudit === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"adminname","label":"任务发布人","width":"94px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"所属客户","width":"84px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.customerid)?_c('span',[_vm._v(_vm._s(scope.row.customername)+"/"+_vm._s(scope.row.customernumber))]):_vm._e(),_vm._v(" "),(!scope.row.customerid)?_c('span',[_vm._v("平台")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"review","label":"审核次数","sortable":"custom","width":"52px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"发布/更新时间","sortable":"custom","width":"94px","prop":"lastupdatetime"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.publishtime)),_c('br'),_vm._v("\n          "+_vm._s(scope.row.lastupdatetime)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"关闭时限","sortable":"custom","width":"94px","prop":"endtime"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.countDown(scope.row.endtime))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"150px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('OrderOperationButtons',{attrs:{"scope":scope}})]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"导出数据确认","visible":_vm.dialogVisible,"width":"45%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticStyle:{"font-size":"large"}},[_vm._v("共导出"+_vm._s(_vm.multipleSelection.length)+"条数据")]),_vm._v(" "),_c('el-checkbox',{staticClass:"margin t20",model:{value:(_vm.exportAsync),callback:function ($$v) {_vm.exportAsync=$$v},expression:"exportAsync"}},[_vm._v("后台异步导出（建议1w条数据以上时勾选，勾选后请于批量任务列表确认导出数据）\n    ")]),_vm._v(" "),_c('el-checkbox',{staticClass:"margin t20",staticStyle:{"margin-left":"0"},model:{value:(_vm.convert_midan_task),callback:function ($$v) {_vm.convert_midan_task=$$v},expression:"convert_midan_task"}},[_vm._v("米单类型任务转为组内任务导出\n    ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.multipleSelection.length === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportPage(0, 1)}}},[_vm._v("按Dashboard格式导出")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.multipleSelection.length === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportPage(1, 0)}}},[_vm._v("仅导出任务基本数据")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.multipleSelection.length === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportPage(0, 0)}}},[_vm._v("导出任务全部数据")]),_vm._v(" "),(_vm.exportType==='order_new')?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-setting","disabled":_vm.multipleSelection.length === 0,"size":"mini"},on:{"click":function($event){return _vm.showExportFieldDialog('page')}}},[_vm._v("选择导出列")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取消")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"导出数据确认","visible":_vm.dialogBatchVisible,"width":"45%"},on:{"update:visible":function($event){_vm.dialogBatchVisible=$event}}},[_c('div',{staticStyle:{"font-size":"large"}},[_vm._v("共导出"+_vm._s(_vm.pagination.total)+"条数据")]),_vm._v(" "),_c('el-checkbox',{staticClass:"margin t20",model:{value:(_vm.exportAsync),callback:function ($$v) {_vm.exportAsync=$$v},expression:"exportAsync"}},[_vm._v("后台异步导出（建议1w条数据以上时勾选，勾选后请于批量任务列表确认导出数据）\n    ")]),_vm._v(" "),_c('el-checkbox',{staticClass:"margin t20",staticStyle:{"margin-left":"0"},model:{value:(_vm.convert_midan_task),callback:function ($$v) {_vm.convert_midan_task=$$v},expression:"convert_midan_task"}},[_vm._v("米单类型任务转为组内任务导出\n    ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.pagination.total === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportSearch(0, 1)}}},[_vm._v("按Dashboard格式导出")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.pagination.total === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportSearch(1, 0)}}},[_vm._v("仅导出任务基本数据")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.pagination.total === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportSearch(0, 0)}}},[_vm._v("导出任务全部数据")]),_vm._v(" "),(_vm.exportType==='order_new')?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-setting","disabled":_vm.pagination.total === 0,"size":"mini"},on:{"click":function($event){return _vm.showExportFieldDialog('search')}}},[_vm._v("选择导出列")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogBatchVisible = false}}},[_vm._v("取消")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"选择导出列","visible":_vm.dialogExportFieldVisible,"width":"70%","append-to-body":""},on:{"update:visible":function($event){_vm.dialogExportFieldVisible=$event}}},[_c('div',{staticClass:"export-field-actions"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","size":"mini"},on:{"click":_vm.selectAllExportFields}},[_vm._v("全选")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-close","size":"mini"},on:{"click":_vm.clearExportFields}},[_vm._v("取消全选")])],1),_vm._v(" "),_c('el-checkbox-group',{staticClass:"export-field-list",model:{value:(_vm.exportField),callback:function ($$v) {_vm.exportField=$$v},expression:"exportField"}},[_c('el-row',{attrs:{"gutter":12}},_vm._l((_vm.exportFieldOptions),function(field){return _c('el-col',{key:field.key,attrs:{"span":6}},[_c('el-checkbox',{attrs:{"label":field.key}},[_vm._v(_vm._s(field.label))])],1)}),1)],1),_vm._v(" "),_c('el-checkbox',{model:{value:(_vm.exportQuestionEvidence),callback:function ($$v) {_vm.exportQuestionEvidence=$$v},expression:"exportQuestionEvidence"}},[_vm._v("\n      所有题目证据\n    ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogExportFieldVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-download","size":"mini"},on:{"click":_vm.confirmExportFieldSelection}},[_vm._v("确认导出")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"导出前置抓拍准确率数据确认","visible":_vm.dialogSneakSimilarVisible,"width":"30%"},on:{"update:visible":function($event){_vm.dialogSneakSimilarVisible=$event}}},[_c('div',{staticStyle:{"font-size":"large"}},[_vm._v("共导出"+_vm._s(_vm.exportCount)+"条数据")]),_vm._v(" "),_c('el-checkbox',{staticClass:"margin t20",staticStyle:{"margin-left":"0"},model:{value:(_vm.convert_midan_task),callback:function ($$v) {_vm.convert_midan_task=$$v},expression:"convert_midan_task"}},[_vm._v("米单类型任务转为组内任务导出\n    ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"mini","disabled":_vm.exportCount === 0},on:{"click":function($event){return _vm.onExportOrderSneakSimilarity()}}},[_vm._v("导出数据")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function () { _vm.dialogSneakSimilarVisible = false; _vm.convert_midan_task = false;}}},[_vm._v("取消")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"工单数据交换","visible":_vm.dialogExchangeOrderVisible,"close-on-press-escape":false,"close-on-click-modal":false,"width":"40%"},on:{"update:visible":function($event){_vm.dialogExchangeOrderVisible=$event}}},[_c('el-form',{ref:"exchangeOrderForm",attrs:{"model":_vm.exchangeOrderForm,"label-width":"96px","size":"medium"}},[_c('el-form-item',{attrs:{"label":"工单1 ID","prop":"orderid1"}},[_c('el-input',{attrs:{"placeholder":"请输入工单ID,必须为纯数字,例如 66534128"},model:{value:(_vm.exchangeOrderForm.orderid1),callback:function ($$v) {_vm.$set(_vm.exchangeOrderForm, "orderid1", $$v)},expression:"exchangeOrderForm.orderid1"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工单2 ID","prop":"orderid2"}},[_c('el-input',{attrs:{"placeholder":"请输入工单ID,必须为纯数字,例如 66534128"},model:{value:(_vm.exchangeOrderForm.orderid2),callback:function ($$v) {_vm.$set(_vm.exchangeOrderForm, "orderid2", $$v)},expression:"exchangeOrderForm.orderid2"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"warning","size":"mini"},on:{"click":function($event){return _vm.doExchangeOrder()}}},[_vm._v("交换数据")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.closeExchangeOrderDialog()}}},[_vm._v("取消交换")])],1)],1),_vm._v(" "),_c('order-allowance-dialog',{attrs:{"visible":_vm.dialogAllowanceVisible,"info":_vm.allowanceInfo},on:{"closeDialog":function($event){_vm.dialogAllowanceVisible=false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4811:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4812);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("75767075", content, true, {});

/***/ }),

/***/ 4812:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".el-table .cell[data-v-6a376f6e]{white-space:pre-wrap}", "", {"version":3,"sources":["/workspace/src/views/order/pages/OrderArchivedTable.vue"],"names":[],"mappings":"AACA,iCAAiC,oBAAoB,CACpD","file":"OrderArchivedTable.vue","sourcesContent":["\n.el-table .cell[data-v-6a376f6e]{white-space:pre-wrap\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading",staticStyle:{"position":"relative"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("任务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":true}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch($event)}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"任务上线时间","prop":"starttime"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.starttime),callback:function ($$v) {_vm.$set(_vm.search, "starttime", $$v)},expression:"search.starttime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务下线时间","prop":"endtime"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.endtime),callback:function ($$v) {_vm.$set(_vm.search, "endtime", $$v)},expression:"search.endtime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务更新时间","prop":"lastupdatetime"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.lastupdatetime),callback:function ($$v) {_vm.$set(_vm.search, "lastupdatetime", $$v)},expression:"search.lastupdatetime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目 名称/编号 进行搜索","query-request":_vm.getProjectTable,"find-request":_vm.getProjectDetail},on:{"change":function($event){return _vm.projectIdChanged()}},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"订单类型","prop":"type"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择订单类型","clearable":""},model:{value:(_vm.search.type),callback:function ($$v) {_vm.$set(_vm.search, "type", $$v)},expression:"search.type"}},_vm._l((_vm.getSortedTaskTypes),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}},[(item.deprecated)?[_c('span',{staticStyle:{"float":"left","color":"#9ba0a5"}},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.desc)+"\n                ")])]:[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.desc))])]],2)}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次","prop":"batchid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","disabled":!_vm.search.projectid,"id-key":"number","label-key":"detail","value-key":"id","placeholder":"请输入批次 名称/编号 进行搜索","query-request":function (_) { return _vm.getBatchTable(Object.assign({projectid: _vm.search.projectid}, _)); },"find-request":_vm.getBatchDetail},model:{value:(_vm.search.batchid),callback:function ($$v) {_vm.$set(_vm.search, "batchid", $$v)},expression:"search.batchid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"订单状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"multiple":"","placeholder":"请选择订单状态","clearable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.options.taskstatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":String(item.value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务模板ID","prop":"templateid"}},[_c('el-input',{attrs:{"placeholder":"请输入任务模板id"},model:{value:(_vm.search.templateid),callback:function ($$v) {_vm.$set(_vm.search, "templateid", $$v)},expression:"search.templateid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所在区域","prop":"taskmarketareaid"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择所在区域","clearable":""},model:{value:(_vm.search.taskmarketareaid),callback:function ($$v) {_vm.$set(_vm.search, "taskmarketareaid", $$v)},expression:"search.taskmarketareaid"}},_vm._l((_vm.options.taskmarketareaid),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"完成人ID","prop":"userid"}},[_c('el-input',{attrs:{"placeholder":"请输入完成人id","clearable":""},model:{value:(_vm.search.userid),callback:function ($$v) {_vm.$set(_vm.search, "userid", $$v)},expression:"search.userid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务标题","prop":"text"}},[_c('el-input',{attrs:{"placeholder":"请输入关键字","clearable":""},model:{value:(_vm.search.title),callback:function ($$v) {_vm.$set(_vm.search, "title", $$v)},expression:"search.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省市区","prop":"query_areas"}},[_c('containment-area-cascader',{attrs:{"placeholder":"请选择省市区"},model:{value:(_vm.search.query_areas),callback:function ($$v) {_vm.$set(_vm.search, "query_areas", $$v)},expression:"search.query_areas"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"mini"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.resetForm('searchForm')}}},[_vm._v("重置\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',{attrs:{"on-refresh":_vm.onRefresh}},[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"primary","size":"mini"},on:{"click":_vm.showExportSearchDialog}},[_vm._v("按搜索结果导出\n      ")])],1),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_vm._l((_vm.orderArchivedFields),function(attr){return [(attr.prop === 'title')?_c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":'/order/detail/'+scope.row.orderid}},[_c('span',{staticStyle:{"color":"rgb(88, 157, 248)"}},[_vm._v(_vm._s(scope.row.title))])])]}}],null,true)},'el-table-column',attr,false)):(attr.prop === 'userid')?_c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.userid !== 0)?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/users/table?keyword='+scope.row.userid}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v(_vm._s(scope.row.userid))])]):_vm._e()]}}],null,true)},'el-table-column',attr,false)):(attr.prop === 'marketname')?_c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":'/market/table?id='+scope.row.marketid,"target":"_blank"}},[_vm._v("\n              "+_vm._s(scope.row.marketname)+"\n            ")])]}}],null,true)},'el-table-column',attr,false)):_c('el-table-column',_vm._b({},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"150px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":'/order/review/'+scope.row.orderid,"target":"_blank"}},[((scope.row.status !== 4))?_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v("查看\n            ")]):_vm._e()],1)]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"导出数据确认","visible":_vm.dialogBatchVisible,"width":"45%"},on:{"update:visible":function($event){_vm.dialogBatchVisible=$event}}},[_c('div',{staticStyle:{"font-size":"large"}},[_vm._v("共导出"+_vm._s(_vm.pagination.total)+"条数据")]),_vm._v(" "),_c('el-checkbox',{staticClass:"margin t20",model:{value:(_vm.exportAsync),callback:function ($$v) {_vm.exportAsync=$$v},expression:"exportAsync"}},[_vm._v("后台异步导出（建议1w条数据以上时勾选，勾选后请于批量任务列表确认导出数据）\n    ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.pagination.total === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportSearch(1)}}},[_vm._v("仅导出任务基本数据")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.pagination.total === 0,"size":"mini"},on:{"click":function($event){return _vm.onExportSearch(0)}}},[_vm._v("导出任务全部数据")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogBatchVisible = false}}},[_vm._v("取消")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/order-table.06385f5e905842d6de6a.js